export default {
    methods: {
        membershipProducts(membership) {
            if (membership.products.length === 0) {
                return this.trans('No products selected!');
            }

            return membership.products.reduce((productsList, product) => {
                if (productsList.length > 0) {
                    productsList += ', ';
                }

                productsList += product.title;

                return productsList;
            }, '');
        }
    }
}